// extracted by mini-css-extract-plugin
module.exports = {"SenceCardB":"SenceCardB_SenceCardB__DtPE_"};